
export default {
  name: 'AContainer',
};
